import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { Agents } from './pages/Agents';
import { FundCapitalization } from './pages/FundCapitalization';
import { Audit } from './pages/Audit';
import { LiquidityDesk } from './pages/LiquidityDesk';
import { Analytics } from './pages/Analytics';
import { AnchorPortal } from './pages/AnchorPortal';
import { RiskManagement } from './pages/RiskManagement';
import { SupplierPortal } from './pages/SupplierPortal';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<Layout data-id="element-5" />} data-id="element-4">
          <Route index element={<Navigate to="/dashboard" replace data-id="element-7" />} data-id="element-6" />
          <Route path="dashboard" element={<Dashboard data-id="element-9" />} data-id="element-8" />
          <Route path="agents" element={<Agents data-id="element-11" />} data-id="element-10" />
          <Route path="agents/:id" element={<Agents data-id="element-13" />} data-id="element-12" />
          <Route path="audit" element={<Audit data-id="element-15" />} data-id="element-14" />
          <Route path="capitalization" element={<FundCapitalization data-id="element-17" />} data-id="element-16" />
          <Route path="analytics" element={<Analytics data-id="element-19" />} data-id="element-18" />
          <Route path="anchor-portal" element={<AnchorPortal data-id="element-21" />} data-id="element-20" />
          <Route path="liquidity-desk" element={<LiquidityDesk data-id="element-23" />} data-id="element-22" />
          <Route path="risk-management" element={<RiskManagement data-id="element-25" />} data-id="element-24" />

          {/* productized supplier view */}
          <Route path="supplier-funding" element={<SupplierPortal data-id="element-27" />} data-id="element-26" />

          <Route path="*" element={<Navigate to="/dashboard" replace data-id="element-29" />} data-id="element-28" />
        </Route>
      </Routes>
    </BrowserRouter>;
}